import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class FillOrderData {
  public baseCcy: string;
  public nonBaseCcy: string;
  public dealtCcy: string;
  public fillAmt: string;

  public mktSpot: string;
  public mktPoints: any;
  public mktAllIn: any;

  public clientSpot: string;
  public clientPoints: any;
  public clientAllIn: any;

  public stp: boolean;
  public stpHold: boolean;
  public orderId: string;
  public orderRef: string;
  public vehicleCcy: string;
  public positionBookId: string;
  public isInvert: boolean;
  public crosses: Array<FillOrderData>;
  public executionType: number;

  /* as proposed by OMS */
  public lockedValueDate: CubiqTS.Moment | null;

  /* as set by User */
  public valueDate: CubiqTS.Moment | null;

  public settleTenor: CubiqTS.Tenor;
  public adjustedSettleTenor: CubiqTS.Tenor;
  public product: CubiqTS.Product;
}
